module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAkCAYAAABmMXGeAAAAAXNSR0IArs4c6QAAAJ9JREFUSA1jYKAQ/P//PwuIfwFxPYVGQbRDDQRScECZwUBjQC7EBgTIcjHQJFwGTh01kLgQGA1D5PQ4mmyISzUMIzDZgEIG6O0vyOkFyv4GpBmJDDkMZUxAkR4MUQYGTqBYHRZx4oWArmrA4lqQEMUl+ajBkHgYDWN4ehwNitGggIcAnIEnVZDX6oOZjMVg8qpvmIEwGslg6hiIZDCKlwHSxWXe86vdngAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back-mobile.png
// module id = AQyz
// module chunks = 4